/**
 * Proposed sidebar entries for the partners feature — a contribution file the
 * shell merges into the route registry; nothing self-registers. Permissions
 * are the canonical strings from openapi/generated/route_policy.gen.go.
 */
import { CalendarClock, Contact, Users, UsersRound } from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const partnersNavEntries: NavEntry[] = [
  {
    path: "/partners",
    labelKey: "nav.partners",
    icon: Users,
    children: [
      {
        path: "/partners",
        labelKey: "partners.nav.parties",
        icon: Contact,
        permission: "partners.party.read",
      },
      {
        path: "/settings/partner-groups",
        labelKey: "partners.nav.groups",
        icon: UsersRound,
        permission: "partners.customer_group.read",
      },
      {
        path: "/settings/payment-terms",
        labelKey: "partners.nav.paymentTerms",
        icon: CalendarClock,
        permission: "partners.payment_terms.read",
      },
    ],
  },
];
